'use client';

import { useState } from 'react';
import { TbPlayerPlayFilled } from 'react-icons/tb';

import { HeroVideo } from './hero-video';

import { Modal } from '@/components/ui/modal';

/**
 * Botão "Ver como funciona" da hero. No DESKTOP (sm+) abre o popup padrão com o
 * vídeo (3:4). No mobile o botão fica escondido (`hidden sm:inline-flex`): lá o
 * vídeo aparece inline no lugar do dashboard.
 */
export function HowItWorksButton(): React.ReactElement {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="text-ink hidden min-h-[44px] items-center justify-center rounded-full border border-[rgba(222,219,246,0.16)] bg-[linear-gradient(180deg,rgba(40,34,64,0.55),rgba(24,20,38,0.42))] px-8 py-3 text-base font-medium shadow-[0_10px_40px_rgba(0,0,0,0.5),inset_0_1px_0_rgba(255,255,255,0.22),inset_0_-1px_0_rgba(0,0,0,0.25)] backdrop-blur-xl backdrop-saturate-150 transition hover:border-[rgba(222,219,246,0.28)] sm:inline-flex"
      >
        Ver como funciona
      </button>

      <Modal
        open={open}
        onOpenChange={setOpen}
        title="Como funciona o Trakd"
        icon={<TbPlayerPlayFilled size={15} />}
        size="sm"
      >
        <HeroVideo />
      </Modal>
    </>
  );
}
